import {
  ADD_TOOLBAR_TITLE,
  SHOW_SOLICITACOES_SHEET,
  SHOW_OVERLAY,
  MSG_ALERT,
  MSG_NOTIFICATION,
  MSG_CONFIRM,
  CLEAR_ALL_MSG
} from "../actions/actions.type";
import {
  SET_TOOLBAR_TITLE,
  SET_SOLICITACOES_SHEET,
  SET_OVERLAY,
  SHOW_MSG_ALERT,
  SHOW_MSG_NOTIFICATION,
  SHOW_MSG_CONFIRM,
  DESTROY_ALL_MSG
} from "../mutations/mutations.type";

const state = {
  toolbarTitle: "",
  showSolicitacaoSheet: false,
  showOverlay: false,
  overlayZIndex: 5,
  msgAlert: {
    show: false,
    dark: true,
    dismissible: false,
    type: String(),
    color: String(),
    border: String(),
    icon: undefined,
    actions: Array(),
    text: String(),
    timeout: Number()
  },
  msgNotification: {
    show: false,
    dark: true,
    dismissible: false,
    type: String(),
    color: String(),
    border: String(),
    icon: undefined,
    actions: Array(),
    text: String(),
    timeout: Number()
  },
  msgConfirm: {
    show: false,
    hasHtmlContent: false,
    type: String(),
    color: String(),
    icon: String(),
    actions: Array(),
    title: String(),
    text: String()
  }
};

const getters = {
  toolbarTitle(state) {
    return state.toolbarTitle;
  },
  showSolicitacaoSheet(state) {
    return state.showSolicitacaoSheet;
  },
  showOverlay(state) {
    return state.showOverlay;
  },
  overlayZIndex(state) {
    return state.overlayZIndex;
  },
  msgAlert(state) {
    return state.msgAlert;
  },
  msgConfirm(state) {
    return state.msgConfirm;
  }
};

const actions = {
  [ADD_TOOLBAR_TITLE](context, params) {
    return new Promise(resolve => {
      context.commit(SET_TOOLBAR_TITLE, params);
      resolve();
    });
  },
  [SHOW_SOLICITACOES_SHEET](context, params) {
    return new Promise(resolve => {
      context.commit(SET_SOLICITACOES_SHEET, params);
      resolve();
    });
  },
  [SHOW_OVERLAY](context, params) {
    return new Promise(resolve => {
      context.commit(SET_OVERLAY, params);
      resolve();
    });
  },
  [MSG_ALERT](context, params) {
    return new Promise(resolve => {
      context.commit(SHOW_MSG_ALERT, params);
      resolve();
    });
  },
  [MSG_NOTIFICATION](context, params) {
    return new Promise(resolve => {
      context.commit(SHOW_MSG_NOTIFICATION, params);
      resolve();
    });
  },
  [MSG_CONFIRM](context, params) {
    return new Promise(resolve => {
      context.commit(SHOW_MSG_CONFIRM, params);
      resolve();
    });
  },
  [CLEAR_ALL_MSG](context) {
    return new Promise(resolve => {
      context.commit(DESTROY_ALL_MSG);
      resolve();
    });
  }
};

const mutations = {
  [SET_TOOLBAR_TITLE](state, toolbarTitle) {
    state.toolbarTitle = toolbarTitle;
  },
  [SET_SOLICITACOES_SHEET](state, showSolicitacaoSheet) {
    state.showSolicitacaoSheet = showSolicitacaoSheet;
  },
  [SET_OVERLAY](state, overlay) {
    state.showOverlay = overlay.showOverlay;
    if (overlay.overlayZIndex != undefined) {
      state.overlayZIndex = overlay.overlayZIndex;
    }
  },
  [SHOW_MSG_ALERT](state, msgAlert) {
    state.msgAlert = {
      ...state.msgAlert,
      ...msgAlert
    };
  },
  [SHOW_MSG_NOTIFICATION](state, msgNotification) {
    state.msgNotification = {
      ...state.msgNotification,
      ...msgNotification
    };
  },
  [SHOW_MSG_CONFIRM](state, msgConfirm) {
    state.msgConfirm = {
      ...state.msgConfirm,
      ...msgConfirm
    };
  },
  [DESTROY_ALL_MSG](state) {
    state.msgAlert = {
      ...state.msgAlert
    };
    state.msgConfirm = {
      ...state.msgConfirm
    };
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
